"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggers = exports.addLogger = exports.getConfig = exports.initializeConfig = exports.pino = void 0;
const pino_1 = __importDefault(require("pino"));
exports.pino = pino_1.default;
// The goal is to ensure ONLY one version of the logging library is loaded at any time
// const isJest = typeof jest !== 'undefined';
// if (!isJest && globalThis.CVENT_CDF_LOGGING_LIBRARY_LOADED) {
//     const errorMessage = '@cvent/logging module was already loaded, it is being loaded again indicating an issue. This likely happening due to multiple different versions which is not supported';
//     throw Error(errorMessage);
// }
// globalThis.CVENT_CDF_LOGGING_LIBRARY_LOADED = true;
/** An array holding the loggers that have been created. Used to assits in dynamically changing the log levels of loggers. */
const loggers = [];
let thisLoggerConfig;
/**
 * Used to set the internal state of the library. This state is set once, and shared between the CJS and ESM
 * version of the library.
 */
function initializeConfig(loggerConfig) {
    if (!thisLoggerConfig) {
        thisLoggerConfig = loggerConfig;
    } else {
        console.log(thisLoggerConfig)
        throw Error('The logger was already configured');
    }
}
exports.initializeConfig = initializeConfig;
/**
 * Returns the initialized configuration.
 */
function getConfig() {
    return thisLoggerConfig;
}
exports.getConfig = getConfig;
/**
 * Add a logger to the list of loggers being tracked.
 */
function addLogger(logger) {
    loggers.push(logger);
}
exports.addLogger = addLogger;
/**
 * Get all loggers that have been created.
 */
function getLoggers() {
    return loggers;
}
exports.getLoggers = getLoggers;
//# sourceMappingURL=state.cjs.map